import BusinessLandingScreen from './containers/businessLandingScreen'

export {default as BusinessLandingScreenLayout} from './components/businessLandingScreenLayout'

export default BusinessLandingScreen
